/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.validEmail = s => /^([\w!.%+\-])+@([\w\-])+(?:\.[\w\-]+)+$/.test(s);

root.fillNicknameFromRealName = function() {
  const s = $('input[name="user[first_name]"]').val() + ' ' + $('input[name="user[last_name]"]').val();
  return $('input[name="real_name"]').val($.trim(s).substring(0, 19));
};

root.initUseRealName = function() {
  fillNicknameFromRealName();
  if ($('input[name="user[use_real_name]"][value="true"]').is(':checked')) {
    return $('input[name="user[nickname]"]').prop('disabled', true);
  } else {
    return $('input[name="user[nickname]"]').prop('disabled', false);
  }
};

root.toAmPm = function(hour) {
  const h = parseInt(hour) % 24;
  const ampm = (h >= 12) ? "pm" : "am";
  if ((h % 12) === 0) {
    hour = 12;
  } else {
    hour = h % 12;
  }
  const s = hour + " " + ampm;
  return s;
};

root.initContactForm = function() {
  $('#user_voice_phone_number_attributes_enabled').click(function() {
    return $('#user_voice_phone_number_attributes_disabled').prop('disabled', $(this).prop('checked'));
  });
  $('#user_sms_phone_number_attributes_enabled').click(function() {
    return $('#user_sms_phone_number_attributes_disabled').prop('disabled', $(this).prop('checked'));
  });

  $('input[name="user[voice_phone_number_attributes][number]"]').prop('disabled', $('input[id="user_use_sms_for_voice"]').prop('checked'));
  $('input[name="user[voice_phone_number_attributes][number]"]').keyup(function() {
    if (!$('#user_voice_phone_number_attributes_disabled').prop('disabled') && ($.trim($('input[name="user[voice_phone_number_attributes][number]"]').val()).length > 0)) {
      $('#user_voice_phone_number_attributes_enabled').click();
    }
    if ($('#user_voice_phone_number_attributes_disabled').prop('disabled') && ($.trim($('input[name="user[voice_phone_number_attributes][number]"]').val()).length === 0)) {
      return $('#user_voice_phone_number_attributes_enabled').click();
    }
  });
  $('input[name="user[sms_phone_number_attributes][number]"]').keyup(function() {
    if (!$('#user_sms_phone_number_attributes_disabled').prop('disabled') && ($.trim($('input[name="user[sms_phone_number_attributes][number]"]').val()).length > 0)) {
      $('#user_sms_phone_number_attributes_enabled').click();
    }
    if ($('#user_sms_phone_number_attributes_disabled').prop('disabled') && ($.trim($('input[name="user[sms_phone_number_attributes][number]"]').val()).length === 0)) {
      return $('#user_sms_phone_number_attributes_enabled').click();
    }
  });

  $('input[id="user_use_sms_for_voice"]').click(function() {
    const checked = $(this).prop('checked');
    const sms_num = $('input[name="user[sms_phone_number_attributes][number]"]').val();
    $('input[name="user[voice_phone_number_attributes][number]"]').prop('disabled', checked);
    return $('input[name="user[voice_phone_number_attributes][number]"]').val(sms_num);
  });
  $('#edit-best-time-to-sms').click(function() {
    $('#best-time-to-sms-summary').hide();
    return $('#best-time-to-sms-fields').show();
  });
  $('#edit-best-time-to-call').click(function() {
    $('#best-time-to-call-summary').hide();
    return $('#best-time-to-call-fields').show();
  });
  $('#hide-best-time-to-sms').click(function() {
    const start = $('#user_sms_phone_number_attributes_start_time').val();
    const end = $('#user_sms_phone_number_attributes_end_time').val();
    $('#sms-summary-text').html("Best time to contact: " + toAmPm(start) + " to " + toAmPm(end));
    $('#best-time-to-sms-summary').show();
    return $('#best-time-to-sms-fields').hide();
  });
  return $('#hide-best-time-to-call').click(function() {
    const start = $('#user_voice_phone_number_attributes_start_time').val();
    const end = $('#user_voice_phone_number_attributes_end_time').val();
    $('#voice-summary-text').html("Best time to contact: " + toAmPm(start) + " to " + toAmPm(end));
    $('#best-time-to-call-summary').show();
    return $('#best-time-to-call-fields').hide();
  });
};

root.addressTabOpened = event => initAddressMaps();

const fadeDemographicsFlashNotice = function() {
  const flashContainer = $('#demographics-update-status');
  if (flashContainer) {
    return setTimeout(() => flashContainer.fadeOut()
    , 2000);
  }
};

root.initUserForm = function() {
  initInviteForm();
  if ($('form.edit_user').length) {
    initUseRealName();
    initContactForm();
    fillNicknameFromRealName();
    fadeDemographicsFlashNotice();
    $('input[name="user[use_real_name]"]').change(() => initUseRealName());
    $('input[name="user[first_name]"]').keyup(() => fillNicknameFromRealName());
    $('input[name="user[last_name]"]').keyup(() => fillNicknameFromRealName());
    if ($("#user_phone_numbers_attributes_0_number").length) {
      if ($("#user_phone_numbers_attributes_0_number").val().length === 0) {
        $("#alternate-phone-prefs").hide();
      }
      $('#user_phone_numbers_attributes_0_number').keyup(function() {
        if (($("#user_phone_numbers_attributes_0_number").val().length === 0) && ($("#user_phone_numbers_attributes_1_number").val().length === 0)) {
          return $("#alternate-phone-prefs").hide('slow');
        } else {
          return $("#alternate-phone-prefs").show('slow');
        }
      });
    }
    $("#email-update-message").hide();
    $('#contact-help').hide();
    $('#contact-help-button').click(function() {
      $('#contact_prefsModal').foundation('close');
      return setTimeout((() => $('#contactHelpModal').foundation('open')), 200);
    });
    $('.close-contact-help').click(function() {
      $('#contactHelpModal').foundation('close');
      return setTimeout((() => $('#contact_prefsModal').foundation('open')), 200);
    });
    $("#user_email").keyup(function() {
      if (validEmail(this.value)) {
        return $("#email-update-message").show();
      } else {
        return $("#email-update-message").hide();
      }
    });
    $('.user_preferred_locale').change(function() {
      return $(this).parents('form').attr('data-remote', false);
    });

    $('#settings-tabs').on('change.zf.tabs', function(event) {
      initAutofocus($('.is-active'));
      if ($('#addresses-label').parent().hasClass('is-active')) {
        return addressTabOpened(event);
      }
    });
  }

};

/*
$(function() {
  initUserForm();

  $("#settings-tabs").on("change.zf.tabs", function(event, tab) {
    if (tab.prop('id') === 'addresses') {
      initAddressMaps();
    }
  });

  $("#log-in-form").on({'open.zf.reveal'() { return $('#user_login').focus(); }});
  $('#select_all').click(function() { return $("input[name='user_ids[]']").prop("checked", this.checked); });

  //$("button.privacy").button({icons: { secondary: "ui-icon-triangle-1-s" }});
  return $(document).on('open.zf.reveal', '[data-reveal]', function() {
    initUserForm();
  });
});
*/

function initUsersOnLoad() {
  if ($('form.edit_user').length) {
    initUserForm();
  }

  if ($("#settings-tabs").length) {
    $("#settings-tabs").on("change.zf.tabs", function(event, tab) {
      if (tab.prop('id') === 'addresses') {
        initAddressMaps();
      }
    });
  }

  if ($("#log-in-form").length) {
    $("#log-in-form").on({'open.zf.reveal'() { return $('#user_login').focus(); }});
  }

  if ($("#select_all").length) {
    $('#select_all').click(function() { return $("input[name='user_ids[]']").prop("checked", this.checked); });
  }

  $(document).on('open.zf.reveal', '[data-reveal]', function() {
    initUserForm();
  });
}

$(initUsersOnLoad);
document.addEventListener('turbo:load', initUsersOnLoad);

